import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const SINGLE_DIGIT_MONTH_COUNT = 9;

const actions = {
    getBudgets: {
        method: 'GET',
        url: `${BASE_PATH_API}/budgets`,
        params: {
            '$count': true
        }
    },
    getBudget: {
        method: 'GET',
        url: `${BASE_PATH_API}/budgets/:Id`
    },
    deleteBudget: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/budgets/:Id`
    },
    createBudget: {
        method: 'POST',
        url: `${BASE_PATH_API}/budget`
    },
    updateBudget: {
        method: 'PUT',
        url: `${BASE_PATH_API}/budget`
    },
    getPreviousYearBudget: {
        method: 'GET',
        url: `${BASE_PATH_API}/previousYearBudget`
    }
};

export function BudgetsApi(
    BdLocalize,
    $httpParamSerializer
) {
    const service = createActions(actions);

    service.tryParseFloat = function tryParseFloat(val) {
        const floatValue = parseFloat(val);
        if (Number.isNaN(floatValue)) {
            return 0;
        }
        return floatValue;
    };

    service.getMonthName =  function getMonthName(month) {
        return `${BdLocalize.getString('Accounting.AddEditBudget.Text.Month', 'Month')}${month > SINGLE_DIGIT_MONTH_COUNT ? '' : 0}${month}`;
    };

    service.getBudgetsExportUrl = function getBudgetsExportUrl(params) {
        return `${BASE_PATH_API}/budgets/export?${$httpParamSerializer(params)}`;
    };

    service.getBudgetReportUrl = function getBudgetReportUrl(id) {
        return `${BASE_PATH_API}/budgets/${id}/export`;
    };

    service.getBudgetVsActualReportUrl = function getBudgetVsActualReportUrl(id) {
        return `${BASE_PATH_API}/budgets/${id}/report/budgetvsactual`;
    };

    return service;
}
BudgetsApi.$inject = [
    'BdLocalize',
    '$httpParamSerializer'
];
